export const WCL_CLIENT_ID = 'a21cf850-4cf8-4591-b3e5-906aba0da145';
export const WCL_CLIENT_SECRET = 'ZYBFec16gC0CfwaunQjSAwUCQwEXTKOFo5JkwSze';
